import healGlowLogo from "@/assets/heal-glow-wellness-logo.webp";
import drBrandonRamsey from "@/assets/dr-brandon-ramsey.webp";
import {
  Attribution,
  QuoteCard,
  useInViewRef,
} from "@/components/sections/testimonial/shared";

export function Step3Testimonial() {
  const { ref } = useInViewRef<HTMLElement>();

  return (
    <section ref={ref} className="flex flex-col">
      <h2 className="text-4xl font-bold tracking-tight text-foreground">
        They got our industry{" "}
        <span className="text-gradient-cycle font-bold">immediately.</span>
      </h2>

      <QuoteCard>
        Mind Media understood the Med Spa business, the vibe, our customers and
        what actually makes people{" "}
        <span className="text-gradient-cycle font-bold">book an appointment.</span>
      </QuoteCard>

      <Attribution
        avatarSrc={drBrandonRamsey}
        avatarAlt="Dr. Brandon Ramsey"
        name="Dr. Brandon Ramsey"
        role="Founder, Heal + Glow Wellness"
        logoSrc={healGlowLogo}
        logoAlt="Heal + Glow Wellness logo"
        logoClassName="h-8"
      />
    </section>
  );
}
